export const getErrorMessage = (error: unknown): string => {
  if (typeof error === "object" && error !== null) {
    return "message" in error &&
      typeof (error as Record<string, unknown>).message === "string"
      ? (error as { message: string }).message
      : String(error);
  }

  return String(error);
};
